<template>
  <v-btn
    v-bind="$attrs"
    depressed
    x-large
    class="base-button"
    :ripple="false"
    :class="[
      { 'uppercase': uppercase },
      { 'hover': hover },
      { 'mobile': $vuetify.breakpoint.smAndDown },
      { 'loading': loading },
      { 'outline': outline },
      buttonTypeClass
    ]"
    @click.prevent="emitClick"
    @focus="$emit('focus')"
    @blur="$emit('blur')"
  >
    <div
      v-if="loading"
      style="position: absolute"
    >
      <base-loader
        loading
        color="white"
        margin="0"
      />
    </div>
    <v-icon
      v-if="icon"
      class="button-content"
    >
      {{ icon }}
    </v-icon>
    <div
      v-if="!loading && text"
      class="button-content"
    >
      {{ text }}
    </div>
  </v-btn>
</template>

<script>
export default {
  name: 'BaseButton',
  props: {
    text: {
      type: String,
      default: null
    },
    uppercase: {
      type: Boolean,
      default: true
    },
    hover: {
      type: Boolean,
      default: false
    },
    icon: {
      type: String,
      default: null
    },
    loading: {
      type: Boolean,
      default: false
    },
    color: {
      type: String,
      default: 'primary'
    },
    inverted: {
      type: Boolean,
      default: false
    },
    outline: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    buttonTypeClass () {
      let color = this.color

      if (this.color === 'primary' && this.$vuetify.theme.themes.light.secondary === '#033f60') {
        color = 'info'
      }

      return color + (this.inverted ? '--inverted' : '')
    },
    whiteTextColor () {
      if (this.color === 'white' && this.$vuetify.theme.themes.light.secondary === '#033f60') {
        return 'info'
      } else {
        return 'primary'
      }
    }
  },
  methods: {
    emitClick () {
      if (!this.loading) {
        this.$emit('click')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  @import 'src/styles/variables';

  .theme--light {
    color: $white !important;
  }

  .base-button:focus{
    outline: 5px auto;
    outline-offset: 8px;
    outline-color: black;
  }

  .base-button:active{
    outline: 5px auto;
    outline-offset: 8px;
    outline-color: black;
  }

  .base-button {
    border-radius: 0 !important;
    min-width: 211px !important;
    text-transform: none !important;
    font-size: 18px !important;
    font-weight: 600 !important;
    transition: background-color .3s, color .3s, border .3s;
    &:before {
      opacity: 0 !important;
    }
    &.primary {
      background-color: $secondary !important;
      &:hover {
        background-color: $primary !important;
      }

      &:focus {
        background-color: $primary !important;
      }
    }

    &.info {
      background-color: $info !important;
      &:hover {
        background-color: $primary !important;
        border: 2px solid $info !important;
      }
      &:focus {
        background-color: $primary !important;
        border: 2px solid $info !important;
      }
    }

    &.gold {
      background-color: $gold !important;
      color: white !important;
      &:hover {
        background-color: $gold-hover !important;
        border: 2px solid $gold-hover !important;
      }
      &:focus {
        background-color: $gold-hover !important;
        border: 2px solid $gold-hover !important;
      }
    }

    &.white, &.light-gray {
      color: var(--whiteTextColor) !important;
    }

    &.info--inverted {
      background-color: $white !important;
      color: $primary !important;
      &:hover {
        color: $info !important;
        background-color: $white !important;
      }
      &:focus {
        color: $info !important;
        background-color: $white !important;
      }
    }

    &.primary--inverted {
      background-color: $white !important;
      color: $primary !important;
      &:hover {
        color: $secondary !important;
        background-color: $white !important;
      }

      &:focus {
        color: $secondary !important;
        background-color: $white !important;
      }
    }

    &.error {
      background-color: $error !important;
      border: 2px solid transparent !important;
       &:hover {
        background-color: $white !important;
        border: 2px solid $error !important;
        color: $error !important;
      }
      &:focus {
        background-color: $white !important;
        border: 2px solid $error !important;
        color: $error !important;
      }
    }

  }
</style>
